"use client";

import { c as _c } from "react/compiler-runtime";
import { FC, useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ApiWaveOutcome } from "@/generated/models/ApiWaveOutcome";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-regular-svg-icons";
interface WaveRepOutcomeProps {
  readonly outcome: ApiWaveOutcome;
}
const DEFAULT_AMOUNTS_TO_SHOW = 3;
export const WaveRepOutcome: FC<WaveRepOutcomeProps> = t0 => {
  const $ = _c(59);
  const {
    outcome
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  const winnersCount = outcome.distribution?.filter(_temp).length ?? 0;
  const totalCount = outcome.distribution?.length ?? 0;
  const [showAll, setShowAll] = useState(false);
  let t1;
  if ($[0] !== outcome.distribution || $[1] !== showAll) {
    t1 = () => {
      if (showAll) {
        return outcome.distribution?.map(_temp2) ?? [];
      }
      return outcome.distribution?.slice(0, DEFAULT_AMOUNTS_TO_SHOW).map(_temp3) ?? [];
    };
    $[0] = outcome.distribution;
    $[1] = showAll;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const getAmounts = t1;
  let t2;
  if ($[3] !== getAmounts) {
    t2 = getAmounts();
    $[3] = getAmounts;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [amounts, setAmounts] = useState(t2);
  let t3;
  if ($[5] !== getAmounts) {
    t3 = () => {
      setAmounts(getAmounts());
    };
    $[5] = getAmounts;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== showAll) {
    t4 = [showAll];
    $[7] = showAll;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  const t5 = "tw-overflow-hidden tw-rounded-lg tw-border tw-border-solid tw-border-iron-800 tw-transition-all tw-duration-300 desktop-hover:hover:tw-border-iron-700";
  const t6 = "button";
  let t7;
  if ($[9] !== isOpen) {
    t7 = () => setIsOpen(!isOpen);
    $[9] = isOpen;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = "tw-w-full tw-border-0 tw-px-4 tw-py-3 tw-bg-iron-950";
  const t9 = "tw-flex tw-items-center tw-justify-between";
  const t10 = "tw-flex tw-items-center tw-gap-4";
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="tw-flex tw-items-center tw-justify-center tw-size-10 tw-rounded-xl tw-bg-gradient-to-br tw-from-[#C3B5D9]/20 tw-to-[#C3B5D9]/10 tw-shadow-inner"><FontAwesomeIcon icon={faStar} className="tw-size-5 tw-text-[#C3B5D9] tw-flex-shrink-0 tw-drop-shadow-[0_0_3px_rgba(195,181,217,0.5)]" /></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  const t12 = "tw-text-left";
  let t13;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="tw-text-base tw-font-medium tw-text-[#C3B5D9]">Rep</div>;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  const t14 = "tw-text-sm tw-text-[#C3B5D9]/80";
  const t15 = formatNumberWithCommas(winnersCount);
  const t16 = winnersCount === 1 ? "Winner" : "Winners";
  let t17;
  if ($[13] !== t15 || $[14] !== t16) {
    t17 = <div className={t14}>{t15}{" "}{t16}</div>;
    $[13] = t15;
    $[14] = t16;
    $[15] = t17;
  } else {
    t17 = $[15];
  }
  let t18;
  if ($[16] !== t13 || $[17] !== t17) {
    t18 = <div className={t12}>{t13}{t17}</div>;
    $[16] = t13;
    $[17] = t17;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] !== t11 || $[20] !== t18) {
    t19 = <div className={t10}>{t11}{t18}</div>;
    $[19] = t11;
    $[20] = t18;
    $[21] = t19;
  } else {
    t19 = $[21];
  }
  const t20 = outcome.amount ?? 0;
  let t21;
  if ($[22] !== t20) {
    t21 = formatNumberWithCommas(t20);
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] !== t21) {
    t22 = <div className="tw-text-base tw-font-semibold tw-text-[#C3B5D9]">{t21}</div>;
    $[24] = t21;
    $[25] = t22;
  } else {
    t22 = $[25];
  }
  let t23;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <div className="tw-text-xs tw-text-iron-400">total pool</div>;
    $[26] = t23;
  } else {
    t23 = $[26];
  }
  let t24;
  if ($[27] !== t22) {
    t24 = <div className="tw-flex tw-items-center tw-gap-3"><div className="tw-text-right">{t22}{t23}</div></div>;
    $[27] = t22;
    $[28] = t24;
  } else {
    t24 = $[28];
  }
  let t25;
  if ($[29] !== t19 || $[30] !== t24) {
    t25 = <div className={t9}>{t19}{t24}</div>;
    $[29] = t19;
    $[30] = t24;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="tw-text-iron-300 tw-text-sm tw-font-medium tw-mb-1">Category</div>;
    $[32] = t26;
  } else {
    t26 = $[32];
  }
  const t27 = isOpen ? 0 : -90;
  let t28;
  if ($[33] !== t27) {
    t28 = {
      rotate: t27
    };
    $[33] = t27;
    $[34] = t28;
  } else {
    t28 = $[34];
  }
  let t29;
  let t30;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = {
      duration: 0.2
    };
    t30 = <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />;
    $[35] = t29;
    $[36] = t30;
  } else {
    t29 = $[35];
    t30 = $[36];
  }
  let t31;
  if ($[37] !== t28) {
    t31 = <div className="tw-flex tw-w-full tw-justify-between tw-items-center">{t26}<motion.svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" aria-hidden="true" className="tw-flex-shrink-0 tw-size-4 tw-text-iron-400" animate={t28} transition={t29}>{t30}</motion.svg></div>;
    $[37] = t28;
    $[38] = t31;
  } else {
    t31 = $[38];
  }
  let t32;
  if ($[39] !== outcome.rep_category) {
    t32 = <div className="tw-text-iron-400 tw-text-sm tw-overflow-x-auto tw-max-w-full tw-whitespace-nowrap tw-scrollbar-thin tw-scrollbar-track-iron-900/50 tw-scrollbar-thumb-iron-600/50">{outcome.rep_category}</div>;
    $[39] = outcome.rep_category;
    $[40] = t32;
  } else {
    t32 = $[40];
  }
  let t33;
  if ($[41] !== t31 || $[42] !== t32) {
    t33 = <div className="tw-mt-3 tw-flex tw-flex-col tw-items-start tw-border-t tw-border-solid tw-border-iron-800/50 tw-pt-3 tw-border-x-0 tw-border-b-0">{t31}{t32}</div>;
    $[41] = t31;
    $[42] = t32;
    $[43] = t33;
  } else {
    t33 = $[43];
  }
  let t34;
  if ($[44] !== t25 || $[45] !== t33 || $[46] !== t7) {
    t34 = <button type={t6} onClick={t7} className={t8}>{t25}{t33}</button>;
    $[44] = t25;
    $[45] = t33;
    $[46] = t7;
    $[47] = t34;
  } else {
    t34 = $[47];
  }
  let t35;
  if ($[48] !== amounts || $[49] !== isOpen || $[50] !== setShowAll || $[51] !== showAll || $[52] !== totalCount) {
    t35 = isOpen && <motion.div initial={{
      height: 0,
      opacity: 0
    }} animate={{
      height: "auto",
      opacity: 1
    }} exit={{
      height: 0,
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="tw-overflow-hidden tw-bg-gradient-to-b tw-from-iron-900/50 tw-to-iron-950/50"><div className="tw-divide-y tw-divide-iron-800/30 tw-divide-solid tw-divide-x-0">{amounts.map(_temp4)}{totalCount > DEFAULT_AMOUNTS_TO_SHOW && !showAll && <button className="tw-border-0 tw-w-full tw-px-4 tw-py-3 tw-text-left tw-bg-iron-900 tw-text-[#C3B5D9]/80 tw-text-sm hover:tw-text-[#C3B5D9] tw-transition-all tw-duration-300" onClick={() => setShowAll(true)}><span>View more</span><span className="tw-ml-1 tw-text-iron-400">•</span><span className="tw-ml-1 tw-text-iron-400">{totalCount - DEFAULT_AMOUNTS_TO_SHOW} more</span></button>}</div></motion.div>;
    $[48] = amounts;
    $[49] = isOpen;
    $[50] = setShowAll;
    $[51] = showAll;
    $[52] = totalCount;
    $[53] = t35;
  } else {
    t35 = $[53];
  }
  let t36;
  if ($[54] !== t35) {
    t36 = <AnimatePresence initial={false}>{t35}</AnimatePresence>;
    $[54] = t35;
    $[55] = t36;
  } else {
    t36 = $[55];
  }
  let t37;
  if ($[56] !== t34 || $[57] !== t36) {
    t37 = <div className={t5}>{t34}{t36}</div>;
    $[56] = t34;
    $[57] = t36;
    $[58] = t37;
  } else {
    t37 = $[58];
  }
  return t37;
};
function _temp(d) {
  return !!d.amount;
}
function _temp2(d_0) {
  return d_0.amount ?? 0;
}
function _temp3(d_1) {
  return d_1.amount ?? 0;
}
function _temp4(amount, i) {
  return <div key={`wave-rep-outcome-${amount}-${i}`} className="tw-px-4 tw-py-3 tw-bg-gradient-to-r hover:tw-from-[#C3B5D9]/5 hover:tw-to-transparent tw-transition-colors tw-duration-300"><div className="tw-flex tw-items-center tw-gap-4"><span className="tw-flex tw-items-center tw-justify-center tw-size-8 tw-rounded-lg tw-bg-gradient-to-br tw-from-[#C3B5D9]/10 tw-to-[#C3B5D9]/5 tw-text-[#C3B5D9] tw-text-sm tw-font-semibold">{i + 1}</span><span className="tw-whitespace-nowrap tw-text-[#C3B5D9] tw-text-base tw-font-medium">{formatNumberWithCommas(amount)} Rep</span></div></div>;
}